import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BASE_URL } from '@kikkz/shared/config/util';
import { OriginGameType } from '../enums/origin-game-type';
import { B04User } from '../interfaces/b04-user';

/** Response of POST /api/v1/user (see the generated backend spec, `components.schemas.User`). */
interface B04UserResponse {
  id: string;
  externalId: string;
  username: string;
  imageUrl?: string | null;
  member: boolean;
}

@Injectable({ providedIn: 'root' })
export class B04UserService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = inject(BASE_URL);

  /** Upserts the backend user for the current session (identity comes from the auth token). */
  createOrUpdateUser$(): Observable<B04User> {
    return this.httpClient
      .post<B04UserResponse>(`${this.baseUrl}/api/v1/user`, null, {
        params: new HttpParams().set('originGameType', OriginGameType.predictionGame),
      })
      .pipe(
        map((response) => ({
          id: response.id,
          externalId: response.externalId,
          username: response.username,
          imageUrl: response.imageUrl ?? null,
          member: response.member,
        })),
      );
  }
}
